<template>
    <div class="count-up" key={this.props.bar}>
        {{ value }}
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'CountUp',
    props: ['startValue', 'endValue', 'callback'],
    created() {
        const intervalMs = this.intervalMs;

        if (typeof this.callback === 'function') {
            this.callback(this.value);
        }

        clearInterval(this.refreshInterval);

        if (this.endValue === this.startValue) {
            return;
        }

        setTimeout(() => {
            this.refreshInterval = setInterval(() => {
                if (this.value === this.endValue) {
                    clearInterval(this.refreshInterval);
                }

                if (this.endValue > this.startValue && this.value < this.endValue) {
                    this.incrementValue();
                } else if (this.endValue < this.startValue && this.value > this.endValue) {
                    this.decrementValue();
                }

                if (typeof this.callback === 'function') {
                    this.callback(this.value);
                }
            }, intervalMs);
        }, 400);
    },
    beforeUnmount() {
        clearInterval(this.refreshInterval);
    },
    data() {
        return {
            value: this.startValue,
            refreshInterval: null,
            refreshTimeout: moment().format(),
            intervalMs: 50,
        };
    },
    methods: {
        incrementValue() {
            this.value += 1;

            if (this.intervalMs > 0) {
                this.intervalMs -= 2;
            }
        },
        decrementValue() {
            this.value -= 1;

            if (this.intervalMs > 0) {
                this.intervalMs -= 2;
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .count-up {

    }

</style>
